import React from "react";
import { Link } from "react-router-dom";
import { useResume } from "../../data/dataCtx";

export const Navigation = ()=> {
   const resume = useResume();
   return (<nav class="navbar navbar-expand-lg navbar-light bg-white py-3">
   <div class="container px-5">
       <Link className="navbar-brand" to="/"><span class="fw-bolder text-primary">
         {resume.main?.name}
        </span></Link>
       <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
       <div class="collapse navbar-collapse" id="navbarSupportedContent">
           <ul class="navbar-nav ms-auto mb-2 mb-lg-0 small fw-bolder">
               <Link className="nav-link" to='/'><li class="nav-item">Home</li></Link>
               <Link className="nav-link" to="/resume"><li class="nav-item">Resume</li></Link>
               <Link className="nav-link" to="/projects"><li class="nav-item">Projects</li></Link>
               <Link className="nav-link" to="/contact"><li class="nav-item">Contacts</li></Link>
           </ul>
       </div>
   </div>
</nav>)
}
